import { omit } from 'ramda';
import { ZapierField__Input } from '~/graphql/types';
import type { ZapierFieldsFE } from '../Details/types';

export const cleanedFields = (
  fields: ZapierFieldsFE,
): Array<ZapierField__Input> =>
  fields.map(field => {
    // Remove fields that shouldn't be sent to GraphQL
    const cleanedField = omit(['__typename', 'id'], field);

    return cleanedField as ZapierField__Input;
  });
